module.exports = __webpack_public_path__ + "static/media/woman-fade-mob.611adea4.jpg";